import { Block } from 'baseui/block';
import { Button, KIND, SIZE, SHAPE } from 'baseui/button';
import { Grid, Cell } from 'baseui/layout-grid';
import { Input } from 'baseui/input';
import { LabelMedium, LabelSmall } from 'baseui/typography';
import { RadioGroup } from 'baseui/radio';
import { Textarea } from 'baseui/textarea';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import remove from 'lodash/remove';
import Plus from 'baseui/icon/plus';
import * as React from 'react';
import ReactJsonEditorAjrm from 'react-json-editor-ajrm';
import { BaseLi } from '../common/list';
import { EditModeInput } from '../common/Input';
import type { QnAStateType, QuestionType } from '../../reducers';
import { QuestionStyleContext } from '../../question-style-context';
import { VSpacer } from '../common/layout';
import { XIcon } from '../common/Icons';
import { getUserAnswersByQuestionId } from '../../reducers/selectors';
import { omitAndDeepEqual } from '../../utils/object';
import Radio from '../common/Radio';
type Props = {
  state: QnAStateType;
  question: QuestionType;
  updateQuestion: Function;
  showOptions: boolean;
  editMode: boolean;
};
const Answers = ({
  state,
  question,
  updateQuestion,
  showOptions,
  editMode
}: Props) => {
  const answers = get(question, 'answers');
  const context = React.useContext(QuestionStyleContext);
  // @ts-expect-error todo(ts-migration) TS2339 Property 'disableNotes' does not exist on type '{ questionDecorator: (href: any, text: any, key: any) => Element; requiredHintRenderer: (isRequired: any) => Element; defaultTagVisibility: boolean; }'....
  const {
    disableNotes,
    extraAnswerRenderer,
    metadataRenderer
  } = context;
  const [answersInput, setAnswersInput] = React.useState(answers);
  return (
    // @ts-expect-error todo(ts-migration) TS2322 Type '{ children: (Element | Element[])[]; $as: string; margin: string; padding: string; }' is not assignable to type 'IntrinsicAttributes & BlockProps<"div"> & { $style?: StyleObject | ((props: Block...
    <Block $as="ol" margin="0" padding="0">
      <LabelMedium>Answers</LabelMedium>
      <VSpacer />
      {answersInput.map((answerItem, idx) => {
        const note = get(answerItem, 'note') || 'none';
        const noteDesc = get(answerItem, 'noteDesc') || '';
        const noteValidator = get(answerItem, 'noteValidator') || '';
        const noteShowing = showOptions && !disableNotes && (note === 'optional' || note === 'required');
        const answerInput = answersInput[idx];
        return <BaseLi key={`answers-${idx}`}>
            <Grid gridGaps={[6]} gridGutters={[6]} gridMargins={[0]}>
              <Cell span={[3, 7, 11]}>
                <EditModeInput value={answerItem.answer} editMode={!answerItem.virtual && editMode}>
                  <Input disabled={answerItem.virtual} size={SIZE.compact} placeholder="put answer text" value={answerInput.answer} onChange={e => {
                  const nextAnswers = [...answersInput];
                  nextAnswers[idx].answer = e.target.value;
                  setAnswersInput(nextAnswers);
                }} onBlur={e => {
                  updateQuestion({
                    ...question,
                    answers: answersInput
                  });
                }} />
                </EditModeInput>
              </Cell>
              <Cell span={[1]}>
                <EditModeInput hideNoneEdit editMode={!answerItem.virtual && editMode}>
                  <XIcon onClick={e => {
                  const nextAnswers = [...answersInput];
                  remove(nextAnswers, (n, i: number) => i === idx);
                  setAnswersInput(nextAnswers);
                  updateQuestion({
                    ...question,
                    answers: nextAnswers
                  });
                }} />
                </EditModeInput>
              </Cell>
              {showOptions && !disableNotes && <Cell span={[4, 8, 12]}>
                  <div>
                    <LabelSmall>Note</LabelSmall>
                    <div style={{
                  verticalAlign: 'top',
                  display: 'inline-block',
                  width: 'calc(100% - 90px)'
                }}>
                      <RadioGroup align="horizontal" value={note} onChange={e => {
                    const nextAnswers = [...answersInput];

                    // @ts-expect-error todo(ts-migration) TS2322 Type 'string' is not assignable to type '"none" | "required" | "optional"'.
                    nextAnswers[idx].note = e.target.value;
                    setAnswersInput(nextAnswers);
                    updateQuestion({
                      ...question,
                      answers: nextAnswers
                    });
                  }}>
                        {/* @ts-expect-error todo(ts-migration) TS2322 Type '{ children: string; value: string; }' is not assignable to type 'IntrinsicAttributes & RadioT'. */}
                        <Radio value="none">None</Radio>
                        {/* @ts-expect-error todo(ts-migration) TS2322 Type '{ children: string; value: string; }' is not assignable to type 'IntrinsicAttributes & RadioT'. */}
                        <Radio value="optional">optional</Radio>
                        {/* @ts-expect-error todo(ts-migration) TS2322 Type '{ children: string; value: string; }' is not assignable to type 'IntrinsicAttributes & RadioT'. */}
                        <Radio value="required">required</Radio>
                      </RadioGroup>
                    </div>
                  </div>
                  <div>
                    <LabelSmall>Metadata</LabelSmall>
                    {metadataRenderer ? metadataRenderer({
                  question,
                  answerItem,
                  idx,
                  updateQuestion: newQuestion => {
                    const nextAnswers = get(newQuestion, 'answers');
                    setAnswersInput(nextAnswers);
                    updateQuestion(newQuestion);
                  }
                }) : !answerItem.metadata ? <div>
                        <Button onClick={() => {
                    const nextAnswers = [...answersInput];
                    nextAnswers[idx].metadata = {};
                    setAnswersInput(nextAnswers);
                    updateQuestion({
                      ...question,
                      answers: nextAnswers
                    });
                  }} kind={KIND.secondary} size={SIZE.compact} shape={SHAPE.pill}>
                          Add metadata
                        </Button>
                      </div> : <div>
                        {/* @ts-expect-error todo(ts-migration) TS2769 No overload matches this call. */}
                        <ReactJsonEditorAjrm id={`meta-${question.id}-${idx}`} placeholder={answerItem.metadata} height="140px" width="100%" onBlur={payload => {
                    const nextAnswers = get(question, 'answers');
                    nextAnswers[idx].metadata = {
                      ...payload.jsObject
                    };
                    updateQuestion({
                      ...question,
                      answers: nextAnswers
                    });
                  }} />
                        <Button onClick={() => {
                    const nextAnswers = get(question, 'answers');
                    nextAnswers[idx].metadata = null;
                    updateQuestion({
                      ...question,
                      answers: nextAnswers
                    });
                  }} kind={KIND.secondary} size={SIZE.compact} shape={SHAPE.pill}>
                          Remove metadata
                        </Button>
                      </div>}
                  </div>
                </Cell>}
              {noteShowing && <Cell span={[4, 8, 12]}>
                  <div>
                    <LabelSmall>Note description</LabelSmall>
                    <Input overrides={{
                  Root: {
                    style: {
                      width: `calc(100% - 150px)`
                    }
                  }
                }} value={noteDesc} onChange={e => {
                  const nextAnswers = get(question, 'answers');
                  nextAnswers[idx].noteDesc = e.target.value;
                  updateQuestion({
                    ...question,
                    answers: nextAnswers
                  });
                }} />
                  </div>
                </Cell>}
              {noteShowing && <Cell span={[4, 8, 12]}>
                  <div>
                    <LabelSmall>Note Validator (JavaScript)</LabelSmall>
                    <Textarea overrides={{
                  Input: {
                    style: {
                      resize: 'vertical'
                    }
                  }
                }} value={noteValidator} placeholder="JavaScript function..." size={SIZE.mini} onChange={e => {
                  const nextAnswers = get(question, 'answers');
                  nextAnswers[idx].noteValidator = e.target.value;
                  updateQuestion({
                    ...question,
                    answers: nextAnswers
                  });
                }} />
                  </div>
                  <VSpacer />
                </Cell>}
            </Grid>
          </BaseLi>;
      })}
      {extraAnswerRenderer && <Cell span={[4, 8, 12]}>
          {extraAnswerRenderer({
          question,
          updateQuestion,
          editMode,
          showOptions
        })}
        </Cell>}

      <EditModeInput hideNoneEdit editMode={editMode}>
        <Button onClick={() => {
          const nextAnswers = get(question, 'answers');
          nextAnswers.push({
            answer: '',
            note: 'none'
          });
          setAnswersInput(nextAnswers);
          updateQuestion({
            ...question,
            answers: nextAnswers
          });
        }} kind={KIND.secondary} size={SIZE.compact} shape={SHAPE.pill}>
          <Plus /> Add Answer
        </Button>{' '}
      </EditModeInput>
    </Block>
  );
};
export default React.memo<Props>(Answers, (props, nextProps) => {
  // ignore state, deep compare
  // @ts-expect-error todo(ts-migration) TS2322 Type 'string' is not assignable to type 'never'.
  if (!omitAndDeepEqual(props, nextProps, ['state'])) {
    return false;
  }

  // performance optimization
  // ignoring user note updates
  // ignore, question and user's answers stayed the same
  if (isEqual(props.question, nextProps.question)) {
    const userAnswers = getUserAnswersByQuestionId(props.state, get(props, ['question', 'id']));
    const nextUserAnswers = getUserAnswersByQuestionId(nextProps.state, get(nextProps, ['question', 'id']));
    if (isEqual(userAnswers, nextUserAnswers)) {
      return true;
    }
    return false;
  }

  // question changed then, check if answers are changed
  return isEqual(get(props, 'question.answers'), get(nextProps, 'question.answers'));
});